import {
    FT5_ADD_ACTION_TO_EVENT_TRACKING,
    FT5_ADD_TO_EVENT_TRACKING,
    FT5_EVENT_TRACKING,
    FT5_MOVE_ACTION_TRACKING,
    FT5_MOVE_TRACKING,
    FT5_TRACK_ON_NEXT_PAGE_IMPRESSION,
    FT5_VIEW_FEATURES_TRACKING,
    FT5_VIEW_TRACKING,
} from '../../constants';
import { initializeOProduct } from './product.const';
import { NamedTrackingFeatures, TrackData, TrackingFeatures } from '../../tracking/client/event-data-types';
import { Action, ActionName, DataContainer } from '@otto-ec/tracking-bct';

type withEventMergeId<T> = T & {
    eventMergeId?: string;
};

export function getGlobalEventMergeId(): string | undefined {
    initializeOProduct();
    return o_product.tracking.eventMergeId;
}

export function setGlobalEventMergeId(eventMergeId?: string): void {
    initializeOProduct();
    o_product.tracking.eventMergeId = eventMergeId;
}

export function generateEventMergeId(): string {
    // prettier-ignore
    const chars = [
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
        'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
        'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
    ];
    let id = '';
    for (let i = 0; i < 10; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        id += chars[randomIndex];
    }
    return id;
}

/**
 * TODO refactor to "getGlobalEventMergeIdIfVariationChanged". We dont need to modify object here. Single responsibility principal
 */
export function addEventMergeIdIfVariationChangedAndExists<T>(payload: T): withEventMergeId<T> | T {
    if (o_product.state.isVariationChanged) {
        return {
            ...payload,
            eventMergeId: getGlobalEventMergeId(),
        };
    }

    return payload;
}

/**
 * use this method to track a submit event
 * @param data any data passed to click tracking
 */
export function trackEvent(data: TrackData): void {
    o_global.eventQBus.emit(FT5_EVENT_TRACKING, data);
}

/**
 * use this method to track a submit move action
 * @param data labels to track on move action
 * @param action action that is supposed to be tracked
 */
export function trackMoveAction(data: DataContainer, action: Action): void {
    o_global.eventQBus.emit(FT5_MOVE_ACTION_TRACKING, data, action);
}

/**
 * use this method to track a submit move
 * @param data any data passed to move tracking
 */
export function trackMove(data: TrackData): void {
    o_global.eventQBus.emit(FT5_MOVE_TRACKING, data);
}

/**
 * use this method to track clicks and actions and to merge it to an existing submitted event.
 * @param data any data passed to click tracking
 * @param eventMergeId event merge id of event you want to add to
 */
export function trackAddToEvent(data: TrackData, actionName: ActionName, eventMergeId: string): void {
    o_global.eventQBus.emit(FT5_ADD_TO_EVENT_TRACKING, data, actionName, eventMergeId);
}

/**
 * use this function to track a view
 * @param data any data passed to view tracking
 */
export function trackView(data: TrackData): void {
    o_global.eventQBus.emit(FT5_VIEW_TRACKING, data);
}

/**
 * use this function to track a view feature
 * @param data any data passed to view tracking
 */
export function trackViewFeatures(data: TrackingFeatures): void {
    o_global.eventQBus.emit(FT5_VIEW_FEATURES_TRACKING, data);
}

/**
 * use this function to add tracking features to an event
 * @param data name of action and features to track
 */
export function trackAddActionToEvent(data: NamedTrackingFeatures, eventMergeId: string): void {
    o_global.eventQBus.emit(FT5_ADD_ACTION_TO_EVENT_TRACKING, data, eventMergeId);
}

export function trackOnNextPageImpression(data: DataContainer): void {
    o_global.eventQBus.emit(FT5_TRACK_ON_NEXT_PAGE_IMPRESSION, data);
}
